import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'giftCardTopUpLocationId',
  initialState: null as string | null,
  reducers: {
    setGiftCardTopUpLocationId(state, action: PayloadAction<any>) {
      return action.payload;
    },
  },
});

export const { setGiftCardTopUpLocationId } = slice.actions;

export default slice.reducer;
